import { useState, useEffect, MutableRefObject, Ref, useRef, useMemo } from 'react';

const useWindowWidth = () => {
  const [width, setWidth] = useState(0);
  useEffect(() => {
    const updateSize = () => {
      setWidth(window.innerWidth);
    };
    window.addEventListener('resize', updateSize);
    updateSize();
    return () => window.removeEventListener('resize', updateSize);
  }, []);

  return width;
};

const getVariantWidth = (ref: MutableRefObject<HTMLDivElement | undefined>) => {
  const VARIANT_WIDTH = 50;
  const productCardChild = ref?.current?.firstChild as HTMLDivElement;
  const productCardWidth = productCardChild?.clientWidth;
  return productCardWidth ? productCardWidth / VARIANT_WIDTH : 0;
};

export const useMaxVariants = (): [number, Ref<HTMLDivElement>] => {
  const ref = useRef<HTMLDivElement | undefined>(undefined);
  const size = useWindowWidth();
  const maxVariants = useMemo(() => {
    if (!ref.current) {
      return 0;
    }
    const MAX_VARIANTS = 6;
    const variantWidth = getVariantWidth(ref);
    const max = Math.floor(variantWidth) - 1;
    return max > MAX_VARIANTS ? MAX_VARIANTS : max;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ref.current, size]);

  return [maxVariants, ref as Ref<HTMLDivElement>];
};
